var _circle, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommented(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#008B80"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8597 27.302C23.1916 27.8961 24.6672 28.2267 26.2191 28.2267C26.35 28.2267 26.48 28.2242 26.6098 28.2172C27.0501 28.2001 27.4468 27.9397 27.6392 27.5407C27.8319 27.1404 27.7873 26.6668 27.5237 26.3099C26.9627 25.5389 26.5173 24.6791 26.2126 23.7551C27.4798 21.9935 28.2266 19.8333 28.2266 17.5C28.2266 11.5796 23.4201 6.77319 17.4998 6.77319C11.5794 6.77319 6.77344 11.5797 6.77344 17.5C6.77344 23.4203 11.5796 28.2268 17.4998 28.2268C19.0518 28.2268 20.5274 27.8962 21.8596 27.3021L21.8597 27.302ZM26.1512 26.8126C24.7243 26.8025 23.3734 26.4712 22.1677 25.8867C21.9731 25.7924 21.746 25.7924 21.5515 25.8867C20.3263 26.4803 18.9519 26.8129 17.4999 26.8129C12.3602 26.8129 8.18671 22.6398 8.18671 17.4998C8.18671 12.3601 12.3598 8.18661 17.4999 8.18661C22.6395 8.18661 26.813 12.3597 26.813 17.4998C26.813 19.641 26.0891 21.6142 24.8723 23.1879C24.7347 23.3663 24.6899 23.5997 24.7526 23.8164C25.0638 24.8943 25.5395 25.9027 26.1511 26.8124L26.1512 26.8126Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.36 14.7719H22.6394C23.0295 14.7719 23.3461 14.4551 23.3461 14.0652C23.3461 13.6754 23.0294 13.3587 22.6394 13.3587H12.36C11.9699 13.3587 11.6533 13.6754 11.6533 14.0652C11.6533 14.4553 11.97 14.7719 12.36 14.7719Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.36 21.6415H20.8395C21.2297 21.6415 21.5462 21.3248 21.5462 20.935C21.5462 20.5449 21.2295 20.2283 20.8395 20.2283H12.36C11.9699 20.2283 11.6533 20.5451 11.6533 20.935C11.6533 21.3248 11.9701 21.6415 12.36 21.6415Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.36 18.2069H22.6394C23.0295 18.2069 23.3461 17.8902 23.3461 17.5002C23.3461 17.1101 23.0294 16.7936 22.6394 16.7936H12.36C11.9699 16.7936 11.6533 17.1103 11.6533 17.5002C11.6533 17.8904 11.97 18.2069 12.36 18.2069Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommented);
export default __webpack_public_path__ + "static/media/commented.854a10ac2749a58375d78e4685c6d7b5.svg";
export { ForwardRef as ReactComponent };